import {createReducer} from "util/redux";
import {CFMember, CFModel} from "module/CustomField/type/CFType";
import {appInitAction} from "util/ReduxUtil";
import {getAndRemoveParams} from 'module/UrlParam/util/UrlParamUtil'
import {UrlParamKey, UrlParamPrefix} from 'module/UrlParam/constant/UrlParamConstant'
import {urlParamSetAction} from 'module/UrlParam/action/UrlParamAction'

export type UrlParamsState = {
	model?: CFModel,
	autoSubmit?: string
	format?: string
}

const reducer = createReducer<UrlParamsState>({}, builder => builder
	.addCase(appInitAction, () => {
		const urlParams = getAndRemoveParams((key) =>
			Object.values(UrlParamPrefix)
				//clipboard handled in ClipboardReducer to prevent timing issues!
				.filter(x => x !== UrlParamPrefix.Clipboard)
				.some(prefix => key.startsWith(prefix))
			||
			Object.values(UrlParamKey).some(k => k === key),
		)
		return Object.entries(urlParams).reduce((result: UrlParamsState, [key, value]) => {
			if (key === UrlParamKey.format) {
				result.format = value
			} else if (key === UrlParamKey.autoSubmit) {
				result.autoSubmit = value
			} else if (key.startsWith(UrlParamPrefix.CFModel)) {
				let field: string = key.substring(UrlParamPrefix.CFModel.length);
				if (!result.model) result.model = {}
				if (field.startsWith("cf.")) {
					let i = field.lastIndexOf(':');
					const {cf} = result.model;
					let cfMembers: CFMember[] = cf ? [...cf] : [];
					if (i < 0) {
						cfMembers.push({data: value, pos: 0, dstField: field.slice(3, field.length)})
					} else {
						let dstField = field.substring(3, i);
						let pos = parseInt(field.substring(i + 1, field.length)) || 0;
						cfMembers.push({data: value, pos, dstField});
					}
					result.model.cf = cfMembers;
				} else {
					result.model[field] = value;
				}
			}
			return result;
		}, {});
	}).addCase(urlParamSetAction, (state, {payload}) => ({
		...state,
		...payload,
	})),
)

export const UrlParamReducerNS = {
	UrlParams: reducer,
};

export type UrlParamStateType = { UrlParams: ReturnType<typeof UrlParamReducerNS.UrlParams> }